export const API_url = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '4889669a-f9c0-4221-aa14-612301692a9f';
export const MODAL_CLOSE_SEC = 2.5;
